import { apolloClient } from "@/plugins/vue-apollo.js";

const createLandlord = (_variables) => {
  // , limit, skip
  let responseFromApi;
  let variables = _variables;

  responseFromApi = apolloClient
    .mutate({
      mutation: require("@/landlord/api/mutations/create_landlord.graphql"),
      variables: variables,
    })
    .catch(error => {
      return error;
    });
  return responseFromApi;
};
export { createLandlord };
